import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'tab.name.journey': {
    id: 'tab.name.journey',
    defaultMessage: 'Journey',
    description: 'Tab name for journey',
  },
  'tab.name.community': {
    id: 'tab.name.community',
    defaultMessage: 'Community',
    description: 'Tab name for community',
  },
  'tab.name.live': {
    id: 'tab.name.live',
    defaultMessage: 'Live',
    description: 'Tab name for live',
  },
});

export default messages;
